import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_KEY,
	authDomain: "eductionery-98885.firebaseapp.com",
	databaseURL:
		"https://eductionery-98885-default-rtdb.asia-southeast1.firebasedatabase.app",
	projectId: "eductionery-98885",
	storageBucket: "eductionery-98885.appspot.com",
	messagingSenderId: "552927260477",
	appId: "1:552927260477:web:f35f33fff1d16c9e03df54",
	measurementId: "G-8HVBPVW962",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
